import { useContext } from "react";
import { PageNewState, UserSearchDialogContext } from ".";

export const useUserSearchDialogState = () => {
  const { pageState, setPageState } = useContext(UserSearchDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
